import Image from "next/image";
import styles from "./PageLoadPopUp.module.scss";
// import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";

const PageLoadPopUp = ({ showPopup, setShowPopup }: any) => {
  // const { isMobileDevice } = useSelector((state: any) => state.data);

  return (
    <Modal
      show={showPopup}
      onHide={() => setShowPopup(false)}
      backdrop="static"
      keyboard={false}
      backdropClassName={styles.custom_backdrop}
      dialogClassName={styles.modelnomore}
      contentClassName={styles.modalContent}
    >
      <div className={styles.bodywp}>
        <Image
          src="https://mms-delivery.sitecorecloud.io/api/media/v2/delivery/545ff802-4b88-4b4b-1933-08dc23ac2ebb/62edf89848eb402b9ac038627753790d"
          alt="Cranleigh Logo"
          width={88}
          height={30}
          className={styles.pic}
        />
        <h4>Welcome to Cranleigh</h4>
        <p>You're in the right place, We've Moved Temporarily</p>
        <button
          className={styles.ctaButton}
          onClick={() => setShowPopup(false)}
        >
          CONTINUE TO OUR SITE
        </button>
      </div>
    </Modal>
  );
};

export default PageLoadPopUp;
